import clsx from "clsx";
import { Icon } from "../icon/icon";

export type PillVariants =
  | "grey"
  | "purple"
  | "green"
  | "red"
  | "blue"
  | "yellow"
  | "plain";

export const Pill = ({
  className = "",
  text = "",
  variation,
  style,
  icon,
}: {
  className?: string;
  text: string;
  variation: PillVariants;
  style?: React.CSSProperties;
  icon?: string;
}) => {
  return (
    <p
      className={clsx(
        `h-fit w-fit min-w-max items-center justify-center gap-1 rounded-full !py-[2px] px-[6px] text-center text-sm font-bold uppercase`,
        {
          "bg-grey-50 text-grey-600": variation === "grey",
          "bg-light-purple text-purple": variation === "purple",
          "bg-light-green text-success": variation === "green",
          "bg-lighter-red text-danger": variation === "red",
          "bg-pill-blue-bg text-pill-blue": variation === "blue",
          "bg-lighter-yellow text-yellow": variation === "yellow",
          "border border-grey-100 bg-transparent text-grey-800":
            variation === "plain",
          flex: !!icon,
        },
        className,
      )}
      style={style}
    >
      {icon && <Icon width={16} height={16} svg={icon} />}
      {text}
    </p>
  );
};
